<template>
  <v-app class="app">
    <router-view />
  </v-app>
</template>

<script lang="ts">

import { defineComponent, onMounted, onUpdated, onUnmounted, reactive } from 'vue'
import { useRouter } from 'vue-router';
import { Auth } from 'aws-amplify';

export default defineComponent({
  name: 'App',

  setup() {
    const router = useRouter();

    const state = reactive({
      user: null,
    });

    // Set variable height to commonize height between iOS & another devices.
    const setVariableHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    onMounted(async () => {
      window.addEventListener('resize', setVariableHeight);
      if (!state.user) {
        try {
          const user = await Auth.currentAuthenticatedUser();
          state.user = user;
        } catch (e) {
          console.warn(e);
        }
      }
    });
    onUpdated(async () => {
    });
    onUnmounted(() => {
      window.removeEventListener('resize', setVariableHeight);
    });
    setVariableHeight();

    const logout = async () => {
      await Auth.signOut();
      state.user = null;
      router.push('/login');
    };

    return {
      state,
      logout,
    };
  },
})
</script>

<style lang="scss" scoped>

.app {
  &:deep(.v-application__wrap) {
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);
  }
}

</style>
